export const tariffe = JSON.parse('{"item":{"@type":"ns8:tariffe","tratte":[{"@type":"ns8:tratta","descrizioneStazionamentoDa":"AREZZO","descrizioneStazionamentoA":"AREA METROPOLITANA FI","urbanoPartenza":"false","urbanoDestinazione":"true","tariffa":[{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000018,10","tipo":"Biglietto giornaliero A/R"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000123,20","tipo":"Abbonamento mensile ordinario"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000107,10","tipo":"Abbonamento mensile ridotto ISEE"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0001108,80","tipo":"Abbonamento annuale ordinario"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000963,90","tipo":"Abbonamento annuale ridotto ISEE"}]},{"@type":"ns8:tratta","descrizioneStazionamentoDa":"AREZZO","descrizioneStazionamentoA":"AREA METROPOLITANA FI","urbanoPartenza":"true","urbanoDestinazione":"true","tariffa":[{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000019,50","tipo":"Biglietto giornaliero A/R"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000146,80","tipo":"Abbonamento mensile ordinario"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0000130,70","tipo":"Abbonamento mensile ridotto ISEE"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0001321,20","tipo":"Abbonamento annuale ordinario"},{"@type":"ns8:tariffa","fascia":"Da Km 80 a Km 90","importo":"0001176,30","tipo":"Abbonamento annuale ridotto ISEE"}]}],"localitaArrivo":{"@type":"ns8:localita","localita":"BAGNO A RIPOLI","codiceIstatLocalita":"04800110002","comune":"BAGNO A RIPOLI","codiceIstatComune":"048001","provincia":"FI"},"localitaPartenza":{"@type":"ns8:localita","localita":"BOSSI-CELLAIO","codiceIstatLocalita":"05100220001","comune":"AREZZO","codiceIstatComune":"051002","provincia":"AR"}}}');

export const tariffeDoppie = JSON.parse(
    `{
        "item": {
            "@type": "ns8:tariffe",
            "tratte": [
                {
                    "@type": "ns8:tratta",
                    "descrizioneStazionamentoDa": "REGGELLO",
                    "descrizioneStazionamentoA": "FIRENZE",
                    "urbanoPartenza": "false",
                    "urbanoDestinazione": "false",
                    "tariffa": [
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000009,30",
                            "tipo": "Biglietto giornaliero A/R"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000076,90",
                            "tipo": "Abbonamento mensile ordinario"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000065,90",
                            "tipo": "Abbonamento mensile ridotto ISEE"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000692,10",
                            "tipo": "Abbonamento annuale ordinario"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000593,10",
                            "tipo": "Abbonamento annuale ridotto ISEE"
                        }
                    ]
                },
                {
                    "@type": "ns8:tratta",
                    "descrizioneStazionamentoDa": "REGGELLO",
                    "descrizioneStazionamentoA": "FIRENZE",
                    "urbanoPartenza": "false",
                    "urbanoDestinazione": "true",
                    "tariffa": [
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000010,80",
                            "tipo": "Biglietto giornaliero A/R"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000088,30",
                            "tipo": "Abbonamento mensile ordinario"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000077,40",
                            "tipo": "Abbonamento mensile ridotto ISEE"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000794,70",
                            "tipo": "Abbonamento annuale ordinario"
                        },
                        {
                            "@type": "ns8:tariffa",
                            "fascia": "Da Km 30 a Km 40",
                            "importo": "0000696,60",
                            "tipo": "Abbonamento annuale ridotto ISEE"
                        }
                    ]
                }
            ],
            "localitaArrivo": {
                "@type": "ns8:localita",
                "localita": "FIRENZE CENTRO",
                "codiceIstatLocalita": "04801710002",
                "comune": "FIRENZE",
                "codiceIstatComune": "048017",
                "provincia": "FI"
            },
            "localitaPartenza": {
                "@type": "ns8:localita",
                "localita": "REGGELLO",
                "codiceIstatLocalita": "04803510009",
                "comune": "REGGELLO",
                "codiceIstatComune": "048035",
                "provincia": "FI"
            }
        }
    }`
)

const AREA_METROPOLITANA_FI = 'AREA METROPOLITANA FI';
const AREA_METROPOLITANA_FI_LABEL = 'AREA METROPOLITANA DI FIRENZE';

// Build a rate table for a given leg
export function buildLegTables(ratesObject) {
    const tables = [];
    ratesObject.tratte.forEach((leg) => {
        // leg can be undefined
        if (leg) {
            const id = leg.descrizioneStazionamentoDa + ' <==> ' + leg.descrizioneStazionamentoA;
            if (leg.descrizioneStazionamentoDa === AREA_METROPOLITANA_FI) {
                leg.urbanFromLabel = AREA_METROPOLITANA_FI_LABEL;
            } else {
                leg.urbanFromLabel = ratesObject.localitaPartenza.comune;
            }
            if (leg.descrizioneStazionamentoA === AREA_METROPOLITANA_FI) {
                leg.urbanToLabel = AREA_METROPOLITANA_FI_LABEL;
            } else {
                leg.urbanToLabel = ratesObject.localitaArrivo.comune;
            }
            let table = tables.find((t) => {
                return t.id === id;
            });
            if (table) {
                table.rows.push(buildRateRow(leg));
            } else {
                table = {};
                table.id = id;
                table.slot = leg.tariffa[0].fascia;
                table.rows = [];
                table.rows.push(buildRateRow(leg));
                tables.push(table);
            }
        }
    });
    // Dalle tariffe in vigore dal 01/08/2026 il biglietto giornaliero può non essere presente:
    // la colonna viene mostrata solo se almeno una riga della tratta ha un prezzo giornaliero
    tables.forEach((table) => {
        table.hasDaily = table.rows.some((row) => row.dailyPrice !== undefined);
    });
    return tables;
}

// build a rate row for every kind of ticket
export function buildRateRow(leg) {
    const row = {};
    const urbanFrom = leg.urbanoPartenza === 'true';
    const urbanTo = leg.urbanoDestinazione === 'true';

    // 1. First column: title
    if (!urbanFrom && !urbanTo) {
        row.title = 'Per la sola tratta extra-urbana';
    } else if (urbanFrom && !urbanTo) {
        row.title = 'Comprensivo della tratta extra-urbana e dei servizi urbani nella sola ' + leg.urbanFromLabel;
    } else if (!urbanFrom && urbanTo) {
        row.title = 'Comprensivo della tratta extra-urbana e dei servizi urbani nella sola ' + leg.urbanToLabel;
    } else if (urbanFrom && urbanTo) {
        row.title = 'Comprensivo della tratta extra-urbana e dei servizi urbani a ' + leg.urbanFromLabel + ' e ' + leg.urbanToLabel;
    }

    // 2. Other columns: kind of ticket
    leg.tariffa.forEach((t) => {
        const price = cleanPriceString(t.importo);
        if (t.tipo === 'Biglietto giornaliero A/R') {
            row.dailyPrice = price;
        } else if (t.tipo === 'Abbonamento mensile ordinario') {
            row.montlyPrice = price;
        } else if (t.tipo === 'Abbonamento mensile ridotto ISEE') {
            row.montlyPriceIsee = price;
        } else if (t.tipo === 'Abbonamento annuale ordinario') {
            row.yerlyPrice = price;
        } else if (t.tipo === 'Abbonamento annuale ridotto ISEE') {
            row.yearlyPriceIsee = price;
        }
    });
    return row;
}

export function cleanPriceString(priceString) {
    let price = priceString.replace(/^0+/, '') + ' €';
    return price;
}